import React from 'react';
import { Text, TouchableHighlight, View } from 'react-native';
import styles from '../Styles';
import Throb from './Throb';

export default class SmallButton extends React.Component {
    constructor(props) {
      super(props);

      // props include:
      // - onPress()
      // - buttonStyle
      // - title

    }

    _pressedButton() {
      this.props.onPress();
    }

    render() {
      let coverStyle = styles.smallButton;
      if (!!this.props.buttonStyle) {
        coverStyle = this.props.buttonStyle;
      }
      if (!!(this.props.smaller)) {
        coverStyle = styles.smallerButton;
      }
      if (!!(this.props.hidden)) {
        return (<View style={{width: this.props.smaller ? 150 : 250}}></View>);
      } else {
        return (
          <TouchableHighlight onPress={ () => this._pressedButton() } underlayColor="white">
            <View style={coverStyle}>
              <Throb disabled={this.props.nothrob}>
                <View style={{padding: 5, justifyContent: 'center', alignItems: 'center'}}>
                  <Text style={this.props.textStyle || styles.smallButtonText}>{this.props.title}</Text>
                </View>
              </Throb>
            </View>
          </TouchableHighlight>
        )
      }
    }
}

